var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.504 21.6498L20.343 16.0481C20.0518 15.7834 19.6691 15.6422 19.2757 15.6544C18.8824 15.6666 18.5091 15.8311 18.2348 16.1133L14.6079 19.8432C13.7349 19.6765 11.9799 19.1293 10.1732 17.3273C8.36662 15.5192 7.81949 13.7595 7.65732 12.8926L11.3842 9.26427C11.6667 8.99014 11.8315 8.61683 11.8437 8.22336C11.8559 7.82989 11.7144 7.44712 11.4494 7.15606L5.84919 0.996651C5.58402 0.70468 5.21548 0.527578 4.82183 0.502958C4.42819 0.478338 4.04045 0.608139 3.74097 0.864794L0.452081 3.68533C0.190048 3.94831 0.033649 4.29832 0.0125523 4.66896C-0.010182 5.04786 -0.443648 14.0233 6.51606 20.9859C12.5876 27.0559 20.193 27.5 22.2876 27.5C22.5937 27.5 22.7816 27.4909 22.8317 27.4879C23.2022 27.4671 23.5521 27.31 23.8138 27.0468L26.6328 23.7565C26.8905 23.4579 27.0213 23.0705 26.9972 22.6769C26.9731 22.2833 26.7961 21.9147 26.504 21.6498V21.6498Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImage);
export default __webpack_public_path__ + "static/media/phoneImage.4efb7ba6ba3f091a30bc8c6897599672.svg";
export { ForwardRef as ReactComponent };